import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Toast from '@/volt/Toast.vue'

  import { RouterView } from 'vue-router'
  import AppLayout from '@/layouts/AppLayout.vue'
  import { ModalsContainer } from 'vue-final-modal'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLayout, null, {
      default: _withCtx(() => [
        _createVNode(_unref(RouterView))
      ]),
      _: 1
    }),
    _createVNode(_unref(ModalsContainer)),
    _createVNode(Toast)
  ], 64))
}
}

})